import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "32px",
  height: "27px",
  viewBox: "0 0 32 27",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("desc", null, "Created with Sketch.", -1),
    _createElementVNode("g", {
      id: "list_svg__Symbols",
      stroke: "none",
      "stroke-width": "1",
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      _createElementVNode("g", {
        id: "list_svg__Header/inactive",
        transform: "translate(-980.000000, -31.000000)",
        fill: "#262626",
        "fill-rule": "nonzero"
      }, [
        _createElementVNode("g", {
          id: "list_svg__list-view_outline",
          transform: "translate(976.000000, 25.307692)"
        }, [
          _createElementVNode("path", {
            d: "M35.0770473,18.2718531 L12.3065741,18.2718531 C11.7964889,18.2718531 11.3836214,18.6842168 11.3836214,19.1923077 C11.3836214,19.7003986 11.7964889,20.1127622 12.3065741,20.1127622 L35.0770473,20.1127622 C35.5877478,20.1127622 36,19.7003986 36,19.1923077 C36,18.6842168 35.5877478,18.2718531 35.0770473,18.2718531 Z M12.3065741,8.45367133 L35.0770473,8.45367133 C35.5877478,8.45367133 36,8.04130769 36,7.53321678 C36,7.02512587 35.5877478,6.61276224 35.0770473,6.61276224 L12.3065741,6.61276224 C11.7964889,6.61276224 11.3836214,7.02512587 11.3836214,7.53321678 C11.3836214,8.04130769 11.7964889,8.45367133 12.3065741,8.45367133 Z M35.0770473,29.9309441 L12.3065741,29.9309441 C11.7964889,29.9309441 11.3836214,30.3433077 11.3836214,30.8513986 C11.3836214,31.3594895 11.7964889,31.7718531 12.3065741,31.7718531 L35.0770473,31.7718531 C35.5877478,31.7718531 36,31.3594895 36,30.8513986 C36,30.3433077 35.5877478,29.9309441 35.0770473,29.9309441 Z M7.69181072,7.53321678 C7.69181072,8.5493986 6.86546042,9.37412587 5.84590536,9.37412587 C4.8263503,9.37412587 4,8.5493986 4,7.53321678 C4,6.51703497 4.8263503,5.69230769 5.84590536,5.69230769 C6.86546042,5.69230769 7.69181072,6.51703497 7.69181072,7.53321678 Z M7.69181072,19.1923077 C7.69181072,20.2084895 6.86546042,21.0332168 5.84590536,21.0332168 C4.8263503,21.0332168 4,20.2084895 4,19.1923077 C4,18.1761259 4.8263503,17.3513986 5.84590536,17.3513986 C6.86546042,17.3513986 7.69181072,18.1761259 7.69181072,19.1923077 Z M7.69181072,30.8513986 C7.69181072,31.8675804 6.86546042,32.6923077 5.84590536,32.6923077 C4.8263503,32.6923077 4,31.8675804 4,30.8513986 C4,29.8352168 4.8263503,29.0104895 5.84590536,29.0104895 C6.86546042,29.0104895 7.69181072,29.8352168 7.69181072,30.8513986 Z",
            id: "list_svg__icon-list"
          })
        ])
      ])
    ], -1)
  ])))
}
export default { render: render }